export enum OrganizationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type OrganizationBaseInfoJson = {
  id?: number;
  name?: string;
  description?: string;
  status?: boolean;
};

export type OrganizationJson = {
  id?: number;
  name?: string;
  description?: string;
  organizationStatus?: { id: number; name: OrganizationStatus };
  usersCount?: number;
  companiesCount?: number;
  businessAreasCount?: number;
  tasksCount?: number;
  automationsCount?: number;
  processesCount?: number;
  workflowsCount?: number;
  infrastructureCostsCount?: number;
  predictedManualTime?: number;
  predictedAverageManualTime?: number;
  automationRunTime?: number;
  averageAutomationRunTime?: number;
  totalInvestment?: number;
  totalReturn?: number;
  averageCost?: number;
  averageManualCost?: number;
  canDelete?: boolean;
  profileImageFileId?: number;
  file?: File;
  totalExecutions?: number;
  adminsCount?: number;
};

export type UserOrganizationJson = {
  id?: number;
  name?: string;
  organizationStatus?: { id: number; name: OrganizationStatus };
  usersCount?: number;
  companiesCount?: number;
  roles: Array<{ id: number; name: string }>;
};

export type PagedOrganizations = {
  items: Array<OrganizationJson>;
  rowsPerPage: number;
  totalRows: number;
  totalPages: number;
  currentPage: number;
  hasPrevious: boolean;
  hasNext: boolean;
};

export type ApiResponseOrganizations<T> = {
  isSuccess: boolean;
  timestamp: string;
  data: {
    organizations: T;
  };
};

export type ApiResponseOrganization<T> = {
  isSuccess: boolean;
  timestamp: string;
  data: {
    organization: T;
  };
};

export type OrganizationAutomationPerformanceJson = {
  predictedManualTime?: number;
  automationRunTime?: number;
  totalExecutions?: number;
  totalReturn?: number;
  averageCost?: number;
  totalInvestment?: number;
};
